// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Jtvw","footer":"Form_footer__1kyoE"};